import React, { FC, SVGProps } from 'react'

export const IconChevronUp: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    stroke="var(--typo-primary, #1F2125)"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M18 15L12 9L6 15"
      fill="none"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
